module.exports = __webpack_public_path__ + "img/popup_button_pre_ok.5f05d275.png";